import { ModelPortfolioutilsService } from '../../../services/utils/model-portfolio-utils.service';
import { ModelPortfoliosFacade } from '../facade/model-portfolios.facade';
import * as GlobalNotificationActions from './../../global-notification/actions/global-notification.action';
import { IModelPortfolioSubscription, IPlannedPortfolio } from 'src/app/models/plannedPortfolios';
import { IModelPortfolio } from '../../../models/modelPortfolios';
import * as ModelPortfolioSubscriptionActions from '../actions/model-portfolio-subscription.actions';
import * as ModelPortfoliosActions from './../actions/model-portfolios.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, catchError, map } from 'rxjs/operators';
import { of, Subscription } from 'rxjs';
import { ModelPortfoliosService } from 'src/app/services/http/model-portfolios.service';
import { Injectable } from '@angular/core';

@Injectable()
export class ModelPortfoliosEffects {
  failedTempPlannedPortfolios: number[];
  selectedTempPlannedPortfolio$: Subscription;
  selectedTempPlannedPortfolio: IPlannedPortfolio;

  constructor(
    private actions$: Actions,
    private modelPortfoliosService: ModelPortfoliosService,
    private modelPortfolioUtilsService: ModelPortfolioutilsService,
    private modelPortfoliosFacade: ModelPortfoliosFacade) {
    this.selectedTempPlannedPortfolio$ = this.modelPortfoliosFacade.selectedTempPlannedPortfolio$.subscribe((selectedTempPlannedPortfolio: IPlannedPortfolio) => {
      this.selectedTempPlannedPortfolio = selectedTempPlannedPortfolio;
    });
  }

  getModelPortfolios$ = createEffect(() => this.actions$.pipe(
    ofType<ModelPortfoliosActions.GetModelPortfolios>(ModelPortfoliosActions.ModelPortfoliosActionTypes.GET_MODEL_PORTFOLIOS),
    switchMap((action: ModelPortfoliosActions.GetModelPortfolios) => {
      return this.modelPortfoliosService.getModelPortfolios()
        .pipe(
          switchMap((res: any) => {
            if (res) {
              if (res.errorMessage) {
                return of(
                  new ModelPortfoliosActions.ModelPortfoliosDataError(res.errorMessage),
                  new GlobalNotificationActions.NotificationErrorAction(res.errorMessage)
                );
              } else {
                return of(
                  new ModelPortfoliosActions.GetModelPortfoliosSuccess(res)
                );
              }
            }
          })
          , catchError((err) => {
            return of(
              new GlobalNotificationActions.NotificationErrorAction(err.error.message)
            );
          })
        );
    })
  ));

  submitModelPortfolio$ = createEffect(() => this.actions$.pipe(
    ofType<ModelPortfoliosActions.SubmitModelPortfolio>(
      ModelPortfoliosActions.ModelPortfoliosActionTypes.SUBMIT_MODEL_PORTFOLIO,
      ModelPortfoliosActions.ModelPortfoliosActionTypes.DELETE_MODEL_PORTFOLIO_SUBSCRIPTION),
    switchMap((action: ModelPortfoliosActions.SubmitModelPortfolio | ModelPortfoliosActions.DeleteModelPortfolioSubscription) => {
      return this.modelPortfoliosService.submitModelPortfolio(<IModelPortfolio>action.payload)
        .pipe(
          switchMap((res: IModelPortfolio) => {
            if (res) {
              res.failedRebalancedPortfolios = this.modelPortfolioUtilsService.getFailedRebalancedPorfolios(res);
              return of(
                new ModelPortfoliosActions.SubmitModelPortfolioSuccess(<IModelPortfolio>res),
                new GlobalNotificationActions.NotificationSuccessAction('Model portfolio successfully saved')
              );
            }
          })
          , catchError((err) => {
            const defaultErrorMessage = "Model Portfolio could not be saved";
            let errorMessage: string;
            if (err.error) {
              if (err.error.modelState) {
                const modelState = err.error.modelState;
                if (modelState["viewModel.Positions.Count"]) {
                  errorMessage = modelState["viewModel.Positions.Count"][0];
                } else {
                  errorMessage = defaultErrorMessage;
                }
              } else {
                errorMessage = defaultErrorMessage;
              }
            } else {
              errorMessage = defaultErrorMessage;
            }
            return of(
              new GlobalNotificationActions.NotificationErrorAction(errorMessage),
              new ModelPortfoliosActions.ModelPortfolioDataError(errorMessage)
            );
          })
        );
    })
  ));

  deleteModelPortfolio$ = createEffect(() => this.actions$.pipe(
    ofType<ModelPortfoliosActions.DeleteModelPortfolio>(ModelPortfoliosActions.ModelPortfoliosActionTypes.DELETE_MODEL_PORTFOLIO),
    switchMap((action: ModelPortfoliosActions.DeleteModelPortfolio) => {
      return this.modelPortfoliosService.deleteModelPortfolio(<number>action.payload.modelPortfolioId)
        .pipe(
          switchMap((res: any) => {
            return of(
              new ModelPortfoliosActions.DeleteModelPortfolioSuccess(`Success! You've deleted your ${action.payload.modelPortfolioName} model portfolio.`),
              new GlobalNotificationActions.NotificationSuccessAction(`Success! You've deleted your ${action.payload.modelPortfolioName} model portfolio.`)
            );
          })
          , catchError((err) => {
            return of(
              new GlobalNotificationActions.NotificationErrorAction("Model portfolio could not be deleted"),
              new ModelPortfoliosActions.ModelPortfolioDataError("Model portfolio could not be deleted")
            );
          })
        );
    })
  ));
}

